export default "__VITE_ASSET__Bf84CWff__"